import { DredgingProjectUsageResourceModel, Operation, TunnelingProjectUsageResourceModel } from 'src/app/core/_models/operation';

export type EquipmentProofKind = 'dredging' | 'tunneling';

export interface PendingEquipmentProof {
  item: DredgingProjectUsageResourceModel | TunnelingProjectUsageResourceModel;
  kind: EquipmentProofKind;
  file: File;
}

export function assignCreatedLineIds<T extends { id?: string; displayName: string }>(lines: T[], savedLines: T[]): void {
  const knownIds = new Set(lines.filter((line) => line.id).map((line) => line.id));
  const created = savedLines.filter((line) => line.id && !knownIds.has(line.id));
  lines
    .filter((line) => !line.id)
    .forEach((line) => {
      const index = created.findIndex((c) => c.displayName === line.displayName);
      const match = index >= 0 ? created.splice(index, 1)[0] : created.shift();
      if (match) line.id = match.id;
    });
}

export function assignCreatedEquipmentIds(operation: Operation, savedOperation: Operation): void {
  assignCreatedLineIds(operation.detailedOperation?.dredging ?? [], savedOperation.detailedOperation?.dredging ?? []);
  assignCreatedLineIds(operation.detailedOperation?.tunneling ?? [], savedOperation.detailedOperation?.tunneling ?? []);
}
